import type { components } from '@aurigaengineering/contracts-admin'
import type { ApiClient } from './client'

export type Brand = components['schemas']['BrandView']
export type BrandChange = components['schemas']['ConfigureBrand']
export interface BrandsApi {
  list(): Promise<Brand[]>
  save(code: string, change: BrandChange): Promise<Brand>
}

export function brandsApi(client: ApiClient): BrandsApi {
  return {
    async list() {
      const { data } = await client.GET('/admin/brands')
      if (!data) throw new Error('Unable to read brands.')
      return data
    },
    async save(code, change) {
      const { data, error } = await client.PUT('/admin/brands/{code}', { params: { path: { code } }, body: change })
      if (!data) throw new Error(error?.detail ?? error?.title ?? 'Unable to save the brand.')
      return data
    },
  }
}
